import { render } from "./SkillsAndExpertize.vue?vue&type=template&id=05e10fc6&scoped=true"
import script from "./SkillsAndExpertize.vue?vue&type=script&lang=js"
export * from "./SkillsAndExpertize.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-05e10fc6"

export default script